import React from "react";

const FiltresLogement = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    let newFilters = { ...filters };

    if (type === "checkbox") {
      newFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      newFilters[name] = value;
    }

    onChange(newFilters);
  };

  const uniqueTransactions = [...new Set(annonces.map((a) => a.transaction).filter(Boolean))];
  const uniqueTypes = [...new Set(annonces.map((a) => a.typeBien).filter(Boolean))];
  const uniqueExterieurs = [...new Set(annonces.map((a) => a.exterieur).filter(Boolean))];

  return (
    <div>
      <h3>Transaction</h3>
      {uniqueTransactions.map((t) => (
        <label key={t}>
          <input type="checkbox" name="transaction" value={t} onChange={handleChange} />
          {t}
        </label>
      ))}

      <h3>Type de bien</h3>
      {uniqueTypes.map((t) => (
        <label key={t}>
          <input type="checkbox" name="type" value={t} onChange={handleChange} />
          {t}
        </label>
      ))}

      <h3>Extérieur</h3>
      {uniqueExterieurs.map((e) => (
        <label key={e}>
          <input type="checkbox" name="exterieur" value={e} onChange={handleChange} />
          {e}
        </label>
      ))}

      <h3>Nombre de pièces</h3>
      <input name="nombrePieceMin" type="number" placeholder="Min" onChange={handleChange} />
      <input name="nombrePieceMax" type="number" placeholder="Max" onChange={handleChange} />

      <h3>Prix</h3>
      <input name="prixMin" type="number" placeholder="Min" onChange={handleChange} />
      <input name="prixMax" type="number" placeholder="Max" onChange={handleChange} />
    </div>
  );
};

export default FiltresLogement;
